import { render, staticRenderFns } from "./logistics-create.vue?vue&type=template&id=57c324ec"
import script from "./logistics-create.vue?vue&type=script&lang=ts"
export * from "./logistics-create.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports